import { Image } from '@chakra-ui/react';
import { isImgFile } from '@halo/utils';
import UNKNOWN from './images/UNKNOWN.svg';

const iconModules = import.meta.glob('./images/*.svg', { eager: true });

interface FileTypeIconProps {
  extType: string;
  file?: File;
  src?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
}

export const getFileTypeIconUrl = (extType: string) => {
  try {
    const iconKey = `./images/${extType.toUpperCase()}.svg`;
    const iconModule = iconModules[iconKey];

    if (!iconModule) throw new Error(`File type icon not found: ${extType.toUpperCase()}.svg`);

    return (iconModule as { default: string }).default;
  } catch {
    return UNKNOWN;
  }
};

export const FileTypeIcon = ({
  extType,
  file,
  src,
  width = 34,
  height = 34,
  style,
}: FileTypeIconProps) => {
  const [iconUrl, setIconUrl] = useState<string>(UNKNOWN);

  useLayoutEffect(() => {
    if (src) {
      setIconUrl(src);
      return;
    }

    if (isImgFile(file?.type)) {
      const objectURL = URL.createObjectURL(file!);
      setIconUrl(objectURL);
      return () => {
        URL.revokeObjectURL(objectURL);
      };
    }

    setIconUrl(getFileTypeIconUrl(extType));
  }, [file, extType, src]);

  return (
    <Image
      src={iconUrl}
      width={width}
      height={height}
      borderRadius="5px"
      onError={() => {
        setIconUrl(UNKNOWN);
      }}
      css={style}
    />
  );
};
